module.exports = __webpack_public_path__ + "img/2.06018273.jpg";